import { render, staticRenderFns } from "./_sub_banner.vue?vue&type=template&id=a89a284e"
import script from "./_sub_banner.vue?vue&type=script&lang=js"
export * from "./_sub_banner.vue?vue&type=script&lang=js"
import style0 from "./_sub_banner.vue?vue&type=style&index=0&id=a89a284e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports